export default __webpack_public_path__ + "graphics/bag.6841610f.jpg";